export default __webpack_public_path__ + "static/media/tickets1.5a7c659f.jpg";